import { render } from "./TestChart.vue?vue&type=template&id=5b2a12b5"
import script from "./TestChart.vue?vue&type=script&lang=js"
export * from "./TestChart.vue?vue&type=script&lang=js"

import "./TestChart.vue?vue&type=style&index=0&id=5b2a12b5&lang=css"
script.render = render

export default script